"use client";

import { useEffect, useRef, useState } from "react";

export type Held<V> = { readonly value: V; readonly heldAtMs: number | null };

export function useHeld<V>(live: V, enabled: boolean, key: string, complete: boolean): Held<V> {
  const liveRef = useRef(live);
  liveRef.current = live;
  const [held, setHeld] = useState<{ value: V; at: number; key: string } | null>(null);
  useEffect(() => {
    if (enabled) {
      setHeld(null);
      return;
    }
    if (!complete) return;
    setHeld((current) => (current !== null && current.key === key ? current : { value: liveRef.current, at: Date.now(), key }));
  }, [enabled, complete, key]);
  if (enabled || held === null || held.key !== key) return { value: live, heldAtMs: null };
  return { value: held.value, heldAtMs: held.at };
}
